/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import FieldDropDown from "../../../shared/controls/fieldDropDown";
import FieldTextBox from "../../../shared/controls/fieldTextBox";
import FieldInputNumber from "../../../shared/controls/fieldInputNumber";
import useSeguridad from "../../../Seguridad/useSeguridad";
import constantes from "../../../catalogos/constantes";

const TarifasPermisionario = ({viaje, errors, actualizar, soloLectura = false}) => {
    const seguridad = useSeguridad();
    let permisoAjusteTarifaPermisionario= seguridad.tieneAcceso(constantes.opciones.permisoTarifaPermisionarios)
    return (
        <>           
            <div className="contTabla">
                <table className="table tabla">
                    <thead className="thead-light head">
                    <tr>                      
                        <th scope="col" style={{width: "500px"}}>
                            ORIGEN - DESTINO
                        </th>
                        <th scope="col" style={{width: "200px"}}>
                           UND
                        </th>
                        <th scope="col" style={{width: "100px"}}>
                          UNIDAD
                        </th>
                         <th scope="col" style={{width: "100px"}}>
                          PERMISIONARIO
                        </th>
                        <th scope="col" style={{width: "200px"}}>
                          TARIFA XIMPLE
                        </th>
                        <th scope="col" style={{width: "100px"}}>
                           TARIFA PERMISIONARIO
                        </th>
                 
                    </tr>
                    </thead>
                    <tbody className={"body"}>
                    {viaje.tarifasPermisionarioSegmento?.map((item, index) => {
                        return (
                            <tr key={index}>                              
                                
                                <td className="input">
                                    <FieldTextBox
                                        name="origen"                                    
                                        value={item.origen} 
                                        disabled={true}                                     
                                    />
                                </td>                             
                                <td className="input">
                                        <FieldDropDown
                                        name="unidadDeNegocio"
                                        source="unidadesNegocio"
                                        errors={errors}
                                        params={{ todasLasEmpresas: true }}                                   
                                        colMd={12}
                                        disabled={true}     
                                        filter={true}                                  
                                        value={item.unidadDeNegocio}
                                        onChange={actualizar}
                                    />
                                </td>
                                   <td className="input">
                                       <FieldTextBox
                                        name="origen"                                    
                                        value={item.unidad} 
                                        disabled={true}                                     
                                    />
                                </td>
                                <td className="input">
                                     <FieldDropDown
                                        name="Permisionario"
                                        source="permisionarios"
                                        disabled={true}     
                                        errors={errors}
                                        params={{ todasLasEmpresas: true }}                                   
                                        colMd={12}
                                        filter={true}                                  
                                        value={item.permisionario}
                                        onChange={actualizar}
                                    />

                                </td>
                                <td className="input">
                                    <FieldInputNumber
                                        name="TarifaXimple"
                                        value={item.tarifaXimple}
                                        fractionDigits={3}
                                        errors={errors[`articulos[${index}]`]}
                                        disabled={true}
                                       onChange={actualizar}
                                    />
                                </td>
                                  <td className="input">
                                    <FieldInputNumber
                                        name="tarifaPermisionario"
                                        value={item.tarifaPermisionario}
                                        fractionDigits={3}
                                        errors={errors[`articulos[${index}]`]}
                                       disabled={!permisoAjusteTarifaPermisionario}
                                        
                                    />
                                </td>
                            </tr>
                        );
                    })}
                    </tbody>
                </table>
            </div>
        </>
    );
};

export default TarifasPermisionario;
